import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckTechnologies } from '@api/consistencyCheck';

import { extractQueryParams } from '@utils/common';
import { optionsFormattedWithAvailability } from '@utils/formatter';

import { ICMMavenirVendor, TCMTechnologiesOptions } from '@interfaces/cmModule/cmModule';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { TVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_TECHNOLOGIES } from '@constants/queryKeys';

type TUseConsistencyCheckTechnologies = {
	vendor?: TVendorsValues;
} & ICMMavenirVendor;

const useQueryConsistencyCheckTechnologies = ({ vendor, isMavenirVendor }: TUseConsistencyCheckTechnologies) => {
	const {
		data: technologiesOptions,
		isLoading: isLoadingTechnologiesOptions,
		isFetching: isFetchingTechnologiesOptions,
	} = useQuery<TCMTechnologiesOptions[] | undefined, TSelectOption[]>({
		queryKey: [CONSISTENCY_TECHNOLOGIES, vendor],
		queryFn: extractQueryParams(getConsistencyCheckTechnologies),
		select: (options) => optionsFormattedWithAvailability(options || []),
		enabled: [vendor, !isMavenirVendor],
		...refetchOptions,
	});

	return {
		technologiesOptions: technologiesOptions || [],
		isLoadingTechnologiesOptions: (isLoadingTechnologiesOptions && !!technologiesOptions)
			|| isFetchingTechnologiesOptions,
	};
};

export default useQueryConsistencyCheckTechnologies;
